import { Tag } from 'antd'
import { TeamOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import ClosePosition from '../../../components/PositionColumns/ClosePosition'
import Contracts2 from '../../../components/PositionColumns/Contracts2'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import KrwPrice from '../../../components/PositionColumns/KrwPrice'
import MarkPrice from '../../../components/PositionColumns/MarkPrice'
import Price from '../../../components/PositionColumns/Price'
import RealizeDpl from '../../../components/PositionColumns/RealizeDpl'
import Unrealizedplpercent from '../../../components/PositionColumns/Unrealizedplpercent'
import UserTag from '../../../components/UserTag'
import { COLORS } from '../../../constants'
import { Text } from 'react-konva'

const GroupTag = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
	color: white;
	border-radius: 4px;
	font-size: 10px;
	font-weight: 500;
	white-space: nowrap;
	height: 20px;
`

export const PositionOpenTableColumn: any = (mutate = () => {}, showModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			width: 80,
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '회원',
			align: 'center',
			dataIndex: 'user_id',
			sorter: (a: any, b: any) => b.user_id - b.user_id,
			render: (text, data) => (
				<UserTag
					userid={data?.user_id}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					level={data?.level}
					onClick={() => {
						showModal(data?.user_id)
					}}
				/>
			),
		},
		{
			title: '그룹',
			align: 'center',
			dataIndex: 'referral_code',
			width: 100,
			render: (text, data) => (
				text ? (
					<GroupTag>
						<TeamOutlined style={{ fontSize: 10, marginRight: 2 }} />
						{text}
					</GroupTag>
				) : (
					<span style={{ color: '#999', fontSize: 11 }}>-</span>
				)
			),
		},
		{
			title: '종목',
			align: 'center',
			dataIndex: 'contracts',
			render: (text, data) => <Contracts2 data={data} />,
		},
		{
			title: '구분',
			dataIndex: 'type',
			key: 'type',
			align: 'center',
			width: 70,
			render: (text, record) => (
				<Tag
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignContent: 'center',
						alignItems: 'center',
						color:
							record?.long_short === 'L'
								? COLORS.lightGreen
								: COLORS.lightRed,
					}}>
					{record?.long_short === 'L' ? '매수' : '매도'}
				</Tag>
			),
		},
		{
			title: '수량',
			dataIndex: 'amount',
			align: 'center',
			render: (text, data) => <Price price={text} dp={0} />,
		},
		{
			title: '평단가',
			align: 'center',
			dataIndex: 'price',
			render: (text, data) => (
				<Price price={text} ep_id={data?.exchange_pairs_id} />
			),
		},
		{
			title: '현재가',
			align: 'center',
			dataIndex: 'price',
			render: (text, data) => <MarkPrice data={data} />,
		},
		{
			title: '증거금',
			align: 'center',
			dataIndex: 'margin',
			render: (text, data) => <KrwPrice price={text} />,
		},
		{
			title: '평가손익',
			align: 'center',
			dataIndex: 'unrealizedplpercent',
			render: (text, data) => <Unrealizedplpercent data={data} />,
		},
		{
			title: '실현손익',
			align: 'center',
			dataIndex: 'realizedpl',
			render: (text, data) => <RealizeDpl data={data} />,
		},
		{
			title: '진입일',
			align: 'center',
			dataIndex: 'entryTime',
			render: (text, data) => (
				<EntryTime time={data?.created_at} offset={0} />
			),
		},
		{
			title: '포지션강제종료',
			dataIndex: 'closeBy',
			align: 'center',
			render: (text, data) => (
				<ClosePosition
					data={data}
					onClick={() => {
						showModal(data?.user_id)
					}}
					onSuccess={() => {
						// 포지션 종료 후 데이터 새로고침
						setTimeout(() => {
							mutate && mutate()
						}, 1000)
					}}
				/>
			),
		},
	]
}
